// src/components/Slider.js
import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Demotest = () => {
  
const carouselOneOptions = {
  loop: true,
  margin: 20,
  nav: true,
  dots: true,
  items: 2,
  navText: [
    "<span className='lnr ti-angle-left'></span>",
    "<span className='lnr ti-angle-right'></span>"
  ]
};

const carouselTwoOptions = {
  loop: true,
  margin: 30,
  nav: true,
  dots: true,
  items: 1,
  navText: [
    "<span className='lnr ti-angle-left'></span>",
    "<span className='lnr ti-angle-right'></span>"
  ]
};

  return (
    <div>
      <OwlCarousel className="owl-theme first-carousel" {...carouselOneOptions}>
        <div className="item"><img src="img/rooms/Rajgir.webp" alt="Room 1" /></div>
        <div className="item"><img src="img/rooms/Rajgir-1.webp" alt="Room 2" /></div>
        <div className="item"><img src="img/rooms/Rajgir-2.webp" alt="Room 3" /></div>
      </OwlCarousel>

      
      <OwlCarousel className="owl-theme second-carousel" {...carouselTwoOptions}>
        <div className="item"><img src="img/gallery/img1.webp" alt="Gallery 1" /></div>
        <div className="item"><img src="img/gallery/img2.webp" alt="Gallery 2" /></div>
        <div className="item"><img src="img/gallery/img3.webp" alt="Gallery 3" /></div>
      </OwlCarousel>
    </div>
  );
};

export default Demotest;